import { createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../api/api";

export const getNsdcQuestionThunk = createAsyncThunk(
  "nsdc/get",
  async (type) => {
    let response = await api.get(`getnsdcexamquestions/${type}`);
    return response.data;
  }
);

// export const createNsdcQuestionThunk = createAsyncThunk("nsdc/create", async (body) => {
//   let response = await api.post("savensdcexamquestions",body);
//   return response.data;
// });
export const createNsdcQuestionThunk = async (data) =>
  await api.post(`savensdcexamquestions`, data);
